<template>
    <nav class="nav pf">
        <router-link v-for="item in menus" :key="item.url" :to="item.url"  @click.native="showHint">
            <i class="icon" :class="['icon-'+ item.iconName, , {'new': isNewMessage(item.iconName)}]"></i>
            <span>{{item.title}}</span>
        </router-link>

    </nav>
</template>

<script>
export default {
    name: 'navigation',
    data() {
        return {
            menus: [
                {
                    title: '位置',
                    url: '/location',
                    iconName: 'location'
                },
                {
                    title: '足迹',
                    url: '/footprint',
                    iconName: 'footprint'
                },
                {
                    title: '消息',
                    url: '/message',
                    iconName: 'message'
                },
                {
                    title: '我的',
                    url: '/more',
                    iconName: 'more'
                }
            ],
            messageState: true, //新消息状态
        }
    },
    created(){
        this.showHint()
    },
    methods: {
        /**
         * 判端是否处于有新消息状态
         * @param {String} iconName 图标名称
         * @returns {Boolean} 返回true或false
         */
        isNewMessage(iconName) {
            return iconName === 'message' && this.messageState;
        },
        /**
         * 是否有未读显示红点
         */
        showHint(){
            let data = {
                ver:1,
                method:'getRedLotInfo',
                showLoading:false
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                    this.messageState = res.data.readStatus
                } else {
                    this.$toast({
                        message: resolve.msg,
                        icon: 'close'
                    });
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.nav {
    display: flex;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    border-top: 1px solid #d6dde9;
    background-color: #fff;
    z-index: 999;
    @mixin iconUrl($iconName, $sel) {
        background-image: url('../../assets/images/tabs/'+$iconName+'-'+$sel+'.png');
    }
    a {
        flex: 1;
        display: block;

        .img-option{
            display: block;
            width: 56px;
            height: 56px;
            margin: 6px auto 0;
        }
        .icon {
            display: block;
            width: 56px;
            height: 56px;
            margin: 6px auto 0;
            background-position: center center;
            background-size: 100%;
            background-repeat: no-repeat;
        }
        .icon-location {
            @include iconUrl('location', 'no');
        }
        .icon-footprint {
            @include iconUrl('jy', 'no');
        }
        .icon-message {
            @include iconUrl('message', 'no');
        }
        .icon-more {
            @include iconUrl('my', 'no');
        }

        /* 新消息红点样式 */
        .new {
            position: relative;
            &::after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background-color: #ff6960;
            }
        }

        span {
            display: block;
            font-size: 20px;
            color: #c2c2c2;
            text-align: center;
        }
    }
    .router-link-active {
        span {
            color: #01ADA9;
            font-weight: 600;
        }
        .icon-location {
            @include iconUrl('location', 'active');
        }
        .icon-footprint {
            @include iconUrl('jy', 'active');
        }
        .icon-message {
            @include iconUrl('message', 'active');
        }
        .icon-more {
            @include iconUrl('my', 'active');
        }
    }
}
</style>
